export default __webpack_public_path__ + "ec197d03a63feb95c800a0b16719dfde.png";